export const CHAT_SITUATIONS_FILTER = {
  ALL: 'all',
  ANSWERED: 'atendida',
  UNANSWERED: 'nao_atendida',
  BOT_ATTENDANCE: 'atendimento_bot',
  HUMAN_ATTENDANCE: 'atendimento_humano',
  ASSIGNED: 'atribuida',
  WAITING: 'em_espera'
};

/**
 * @type {Array<{color: string, title: string, label: string, typeOfFilter: string, icon: string}>}
 * @description Icones obtidos do font-awesome
 */
export const buttonsFilterMonitoring = [
  {
    color: 'info',
    title: 'Visualizar todas conversas atendidas e não atendidas',
    label: 'Todos atendimentos',
    typeOfFilter: CHAT_SITUATIONS_FILTER.ALL,
    icon: 'fas fa-list mr-1'
  },
  {
    color: 'success',
    title: 'Visualizar apenas conversas atendidas pelo bot ou por um humano',
    label: 'Atendidas',
    typeOfFilter: CHAT_SITUATIONS_FILTER.ANSWERED,
    icon: 'fas fa-check mr-1'
  },
  {
    color: 'danger',
    title: 'Visualizar apenas conversas não atendidas',
    label: 'Não atendidas',
    typeOfFilter: CHAT_SITUATIONS_FILTER.UNANSWERED,
    icon: 'fas fa-times mr-1'
  },
  {
    color: 'warning',
    title: 'Visualizar apenas conversas atendidas pelo bot',
    label: 'Bot',
    typeOfFilter: CHAT_SITUATIONS_FILTER.BOT_ATTENDANCE,
    icon: 'fas fa-robot mr-1'
  },
  {
    color: 'primary',
    title: 'Visualizar apenas conversas atendidas por um humano',
    label: 'Humano',
    typeOfFilter: CHAT_SITUATIONS_FILTER.HUMAN_ATTENDANCE,
    icon: 'fas fa-user mr-1'
  },
  {
    color: 'primary',
    title: 'Visualizar apenas conversas em espera',
    label: 'Em espera',
    typeOfFilter: CHAT_SITUATIONS_FILTER.WAITING,
    icon: 'fas fa-clock mr-1'
  },
  {
    color: 'primary',
    title: 'Visualizar apenas conversas atribuídas a um atendente',
    label: 'Atribuídas',
    typeOfFilter: CHAT_SITUATIONS_FILTER.ASSIGNED,
    icon: 'fas fa-user-clock mr-1'
  }
];
